export default __webpack_public_path__ + "static/media/google_icon.6b3b0c0e.png";